import React from "react";
import Modal from "../modal/modal";
import PositionEnum from "../../enums/position.enum";
import SizeExtraEnum from "../../enums/size-extra.enum";
import EducatorPreviewer from "../educator-content-reader/educator-previewer/educator-previewer";
import { Languages } from "../educator-content-reader/educator-content-reader.props";
import { ILessonViewerModalProps } from "./lesson-viewer-modal.props";
import "./lesson-viewer-modal.scss";

const LessonViewerModal = ({
  title,
  spanishTitle,
  doolittleMediaBaseUrl,
  doolittleApiBaseUrl,
  activities,
  selectedIndex,
  attemptLanguage,
  isSpanishAvailable,
  handleClose,
  handleGetActivities,
  getActivityReviewToken,
  itemEngineAuthorUri,
  itemEngineItemsUri
}: ILessonViewerModalProps) => (
  <Modal
    size={SizeExtraEnum.XL}
    vPosition={PositionEnum.CENTER}
    handleClose={handleClose}
    title={title}
    showModal={true}
    showClose={true}
    backdrop="static"
    id="lesson-viewer-modal"
    className="lesson-viewer-modal"
    scrollable={true}
    body={
      <EducatorPreviewer
        lessonTitle={Languages[attemptLanguage] === "Spanish" ? spanishTitle : title}
        doolittleBaseMediaUrl={doolittleMediaBaseUrl}
        doolittleBaseApiUrl={doolittleApiBaseUrl}
        activities={activities}
        selectedIndex={selectedIndex}
        previewLanguage={Languages[attemptLanguage]}
        spanishAvailable={isSpanishAvailable}
        handleGetActivities={handleGetActivities}
        getActivityToken={getActivityReviewToken}
        itemEngineAuthorUri={itemEngineAuthorUri}
        itemEngineItemsUri={itemEngineItemsUri}
      />
    }
  />
);

export default LessonViewerModal;
